export default function EducationBox(props){
  return (
    <div className={`${props.className} flex py-5 flex-col w-[320px] lg:w-[380px] border-[0.5px] border-gray-300`}>
      <div className="px-5 mb-2 lg:px-5">
        <p className="text-sm lg:text-xl text-hover">{props.title}</p>
      </div>
      <div className="flex flex-row items-start px-5 lg:px-10">
        <p className="text-xs text-gray-500 lg:text-base">-</p>
        <p className="text-xs text-gray-500 lg:text-base">{props.comment1}</p>
      </div>
      <div className="flex flex-row items-start px-5 lg:px-10">
        <p className="text-xs text-gray-500 lg:text-base">-</p>
        <p className="text-xs text-gray-500 lg:text-base">{props.comment2}</p>
      </div>
    </div>
  );
}